// Jul-2026 (User-Wunsch) — Heartbeat der Ordner-Überwachung ans Backend,
// damit das Dashboard warnt, wenn die Überwachung aus/getrennt ist.
// Aug-2026 (User-Report Jörg): Ein Tab, der die Überwachung NICHT gestartet hat
// (z. B. zweites Gerät/Seiten-Reload), darf den aktiven Status eines anderen
// Geräts nicht mit watching:false überschreiben — sonst Fehlalarme im Dashboard.
import { useEffect, useRef } from "react";
import api from "./api";

export function useWatchHeartbeat(channel, watching, folderName) {
    const wasWatching = useRef(false);
    useEffect(() => {
        const send = (w) => api.post("/documents/outbox/watch-status", {
            channel, watching: w, folder: folderName || "",
        }).catch(() => {});
        if (watching) {
            wasWatching.current = true;
            send(true);
            const t = setInterval(() => send(true), 60000);
            return () => clearInterval(t);
        }
        // Nur ein bewusster Stopp AUS DIESEM Tab meldet watching:false.
        if (wasWatching.current) {
            wasWatching.current = false;
            send(false);
        }
        return undefined;
    }, [channel, watching, folderName]);
}
